import { useState } from "react";
import Textarea from "./Textarea";

## Basic Usage

export function BasicTextarea() {
  const [value, setValue] = useState("");
  return <Textarea value={value} onChange={(e) => setValue(e.target.value)} placeholder="Enter your message..." />;
}

<div style={{ maxWidth: "400px" }}>
  <BasicTextarea />
</div>

---

## With Max Length

export function MaxLengthTextarea() {
  const [value, setValue] = useState("");
  return (
    <Textarea
      value={value}
      onChange={(e) => setValue(e.target.value)}
      placeholder="Limited to 100 characters..."
      maxLength={100}
    />
  );
}

<div style={{ maxWidth: "400px" }}>
  <MaxLengthTextarea />
</div>

---

## Different Sizes

<div style={{ display: "flex", flexDirection: "column", gap: "1rem", maxWidth: "400px" }}>
  <Textarea placeholder="Small textarea" rows={2} />
  <Textarea placeholder="Medium textarea" rows={4} />
  <Textarea placeholder="Large textarea" rows={6} />
</div>

---

## States

<div style={{ display: "flex", flexDirection: "column", gap: "1rem", maxWidth: "400px" }}>
  <div>
    <p style={{ marginBottom: "0.5rem" }}>**Success:**</p>
    <Textarea inputState="success" defaultValue="Valid content" />
  </div>
  <div>
    <p style={{ marginBottom: "0.5rem" }}>**Error:**</p>
    <Textarea inputState="error" defaultValue="Invalid content" />
  </div>
  <div>
    <p style={{ marginBottom: "0.5rem" }}>**Info:**</p>
    <Textarea inputState="info" placeholder="Mixed" />
  </div>
</div>

---

## With Validation

export function ValidationTextarea() {
  const [value, setValue] = useState("");
  return (
    <Textarea
      value={value}
      onChange={(e) => setValue(e.target.value)}
      placeholder="Enter at least 10 characters..."
      validate={() => {
        if (value.length > 0 && value.length < 10) return "Please enter at least 10 characters";
        return null;
      }}
    />
  );
}

<div style={{ maxWidth: "400px" }}>
  <p style={{ marginBottom: "0.5rem" }}>Type less than 10 characters and blur to see validation:</p>
  <ValidationTextarea />
</div>

---

## Disabled State

<div style={{ maxWidth: "400px" }}>
  <Textarea disabled defaultValue="This textarea is disabled and cannot be edited." />
</div>

---

## Comment Box Example

export function CommentBox() {
  const [comment, setComment] = useState("");
  return (
    <div style={{ border: "1px solid #e5e5e5", borderRadius: "8px", padding: "1rem" }}>
      <label style={{ display: "block", marginBottom: "0.5rem", fontWeight: 500 }}>Add a comment</label>
      <Textarea
        value={comment}
        onChange={(e) => setComment(e.target.value)}
        placeholder="Write your comment here..."
        maxLength={500}
        rows={4}
      />
      <div style={{ marginTop: "0.75rem", display: "flex", justifyContent: "flex-end" }}>
        <button
          style={{
            padding: "6px 12px",
            background: "#3b82f6",
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: comment ? "pointer" : "not-allowed",
            opacity: comment ? 1 : 0.5,
          }}
          disabled={!comment}
        >
          Post Comment
        </button>
      </div>
    </div>
  );
}

<div style={{ maxWidth: "400px" }}>
  <CommentBox />
</div>
